import React, { Component } from "react";
import AppModalBs from "../../../partials/AppModalBs";

export default class SelectYearModal extends Component {
  constructor(props) {
    super(props);
    let term = "Half Yearly";
    if (props.isMidYearLocked && !props.isFullYearLocked) {
      term = "Yearly";
    }
    this.state = {
      term: term,
      isSubmitting: false,
      cooldownSeconds: 0,
    };
    this.isProcessing = false;
    this.timer = null;
  }

  getEffectiveTerm = () => {
    const { isMidYearLocked = false, isFullYearLocked = false } = this.props;
    const { term } = this.state;
    if (isMidYearLocked && !isFullYearLocked && term === "Half Yearly") {
      return "Yearly";
    }
    if (isFullYearLocked && !isMidYearLocked && term === "Yearly") {
      return "Half Yearly";
    }
    return term;
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.isMidYearLocked !== prevProps.isMidYearLocked ||
      this.props.isFullYearLocked !== prevProps.isFullYearLocked
    ) {
      const effective = this.getEffectiveTerm();
      if (effective !== this.state.term) {
        this.setState({ term: effective });
      }
    }
    // Only reset isSubmitting once the 10-second cooldown has elapsed
    if (prevProps.isGenerating && !this.props.isGenerating && this.state.cooldownSeconds <= 0) {
      this.isProcessing = false;
      this.setState({ isSubmitting: false });
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.isProcessing = false;
  }

  handleRadioChange = (e) => {
    this.setState({ term: e.target.value });
  };

  startCooldown = (seconds = 10) => {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.setState({ isSubmitting: true, cooldownSeconds: seconds }, () => {
      this.timer = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.cooldownSeconds <= 1) {
            clearInterval(this.timer);
            this.timer = null;
            this.isProcessing = false;
            return {
              cooldownSeconds: 0,
              isSubmitting: false,
            };
          }
          return {
            cooldownSeconds: prevState.cooldownSeconds - 1,
          };
        });
      }, 1000);
    });
  };

  handleSubmit = () => {
    let selectedTerm = this.getEffectiveTerm();
    let isSubmitDisabled = this.isSubmitDisabled(selectedTerm);
    if (
      isSubmitDisabled ||
      this.isProcessing ||
      this.state.isSubmitting ||
      this.state.cooldownSeconds > 0 ||
      this.props.isGenerating
    ) {
      return;
    }

    // Immediately block synchronous multiple clicks
    this.isProcessing = true;

    // Start 10-second countdown cooldown
    this.startCooldown(10);

    if (this.props.onConfirm) {
      this.props.onConfirm(selectedTerm);
    }
  };

  isSubmitDisabled = (selectedTerm) => {
    const { isMidYearLocked = false, isFullYearLocked = false, isGenerating = false } = this.props;
    const { isSubmitting, cooldownSeconds } = this.state;

    if (this.isProcessing || isSubmitting || isGenerating || cooldownSeconds > 0) {
      return true;
    }

    if (isMidYearLocked && isFullYearLocked) {
      return true;
    }

    if (selectedTerm === "Half Yearly" && isMidYearLocked) {
      return true;
    }

    if (selectedTerm === "Yearly" && isFullYearLocked) {
      return true;
    }

    return false;
  };

  render() {
    let { id = "selectYearModal", isMidYearLocked = false, isFullYearLocked = false, isGenerating = false } = this.props;
    let { cooldownSeconds } = this.state;

    let selectedTerm = this.getEffectiveTerm();
    let isSubmitDisabled = this.isSubmitDisabled(selectedTerm);
    let isBusy = this.isProcessing || this.state.isSubmitting || isGenerating || cooldownSeconds > 0;

    let buttonLabel = "Generate Report";
    if (cooldownSeconds > 0) {
      buttonLabel = `Please wait (${cooldownSeconds}s)`;
    } else if (isBusy) {
      buttonLabel = "Generating...";
    }

    return (
      <AppModalBs
        id={id}
        title={<span style={{ fontSize: '20px', lineHeight: '1.4' }}>Please select the year<br />you want to generate?</span>}
        size=""
      >
        <div className="p-4 text-center">
          <div className="d-flex justify-content-center gap-4 mb-5 mt-2">
            <div className="form-check d-flex align-items-center gap-2">
              <input
                className="form-check-input mt-0"
                type="radio"
                name="generateTermType"
                id="generateMidYear"
                value="Half Yearly"
                checked={selectedTerm === "Half Yearly"}
                disabled={isMidYearLocked || isBusy}
                onChange={this.handleRadioChange}
                style={{ cursor: (isMidYearLocked || isBusy) ? 'not-allowed' : 'pointer' }}
              />
              <label
                className={`form-check-label fw-semibold ${(isMidYearLocked || isBusy) ? 'text-muted' : 'text-dark'}`}
                htmlFor="generateMidYear"
                style={{ cursor: (isMidYearLocked || isBusy) ? 'not-allowed' : 'pointer' }}
              >
                Mid Year
              </label>
            </div>
            <div className="form-check d-flex align-items-center gap-2">
              <input
                className="form-check-input mt-0"
                type="radio"
                name="generateTermType"
                id="generateFullYear"
                value="Yearly"
                checked={selectedTerm === "Yearly"}
                disabled={isFullYearLocked || isBusy}
                onChange={this.handleRadioChange}
                style={{ cursor: (isFullYearLocked || isBusy) ? 'not-allowed' : 'pointer' }}
              />
              <label
                className={`form-check-label fw-semibold ${(isFullYearLocked || isBusy) ? 'text-muted' : 'text-dark'}`}
                htmlFor="generateFullYear"
                style={{ cursor: (isFullYearLocked || isBusy) ? 'not-allowed' : 'pointer' }}
              >
                Full Year
              </label>
            </div>
          </div>

          <button
            className="btn btn-warning text-white fw-bold px-5 py-2 w-75"
            disabled={isSubmitDisabled}
            style={{
              backgroundColor: isSubmitDisabled ? '#ccc' : '#ffb300',
              borderColor: isSubmitDisabled ? '#ccc' : '#ffb300',
              cursor: isSubmitDisabled ? 'not-allowed' : 'pointer'
            }}
            onClick={this.handleSubmit}
            data-bs-dismiss={isSubmitDisabled ? undefined : "modal"}
          >
            {buttonLabel}
          </button>
        </div>
      </AppModalBs>
    );
  }
}
